import React, { Component } from 'react';
import { Data } from '../Data';
import PasswordChecklist from "react-password-checklist";

export class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
        this.postPasswordReset = this.postPasswordReset.bind(this);
        this.getActivationInfo = this.getActivationInfo.bind(this);

        this.state = {
            username: '',
            password: '',
            confirmedpassword: '',
            email: '',
			userid: '',
			activationcode: '',
            submitted: false,
            message: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    postPasswordReset(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        if ((this.state.password === this.state.confirmedpassword) && (this.state.password.length > 7)) {
            const { userid, password } = this.state;
            if (userid && password) {
                this.dataService.postPasswordReset(userid, password)
                    .catch(() => {
                        this.setState({ message: "Failed to update password. Please ensure the new password adheres to the required criteria. If the problem continues, contact your HR for help." });
                    });
            }
        }
    }

    getActivationInfo() {
        if (!this.state.message && !this.state.userid) {
            let url = window.location.search;
            const arr = url.slice(1).split(/&|=/); // remove the "?", "&" and "="

            for (let i = 0; i < arr.length; i += 2) {
                const key = arr[i], value = arr[i + 1];
                if ((key === 'id') && value) {
                    this.dataService.getResetPasswordActivationInfo(value).then((data) => {
                        if (data !== "InvalidActivationCode") {
                            this.setState({
                                userid: data.userid,
                                activationcode: value,
                            });
                        }
                        else {
                            this.setState({
                                message: 'Invalid activation code.',
                            });

                        }
                    });
                }
            }	
        }        
    }

    render() {
        const { userid, confirmedpassword, password, submitted, message } = this.state;
        return (
            <div>{!userid ? this.getActivationInfo() : ''}
                <h4>Password Reset</h4>
                <form name="form" onSubmit={this.postPasswordReset}>
                    <div className='login-form-container'>
                        <label className='login-form-label'>PASSWORD</label>
                        <input
                            placeholder="Password"
                            type="password"
                            className={"form-control login-form-text" + (submitted && (!password || (password !== confirmedpassword)) ? ' has-error' : '')}
                            name="password"
                            value={password}
                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()_+-={}\|;:',<.>/])[A-Za-z\d`~!@#$%^&*()_+-={}\|;:',<.>/]{8,}$"
                            title="New password text box"
                            onChange={this.handleChange}
                        />
                        {submitted && !password &&
                            <div className="help-block">Password is required</div>
                        }
                        {submitted && password && (password.length < 8) &&
                            <div className="help-block">Password must contain at least 8 characters</div>
                        }
                        {submitted && password && confirmedpassword && (password !== confirmedpassword) && (password.length > 7) &&
                            <div className="help-block">Password and confirm password are not the same.</div>
                        }
                        <label className='login-form-label'>CONFIRM PASSWORD</label>
                        <input
                            placeholder="Confirm Password"
                            type="password"
                            className={"form-control login-form-text" + (submitted && (!confirmedpassword || (password !== confirmedpassword)) ? ' has-error' : '')}
                            name="confirmedpassword"
                            value={confirmedpassword}
                            onChange={this.handleChange}
                            title="Confirm new password text box"
                        />
                        {submitted && !confirmedpassword &&
                            <div className="help-block">Confirm password is required</div>
                        }
                        {submitted && password && confirmedpassword && (password !== confirmedpassword) &&
                            <div className="help-block">Password and Confirm Password are not the same</div>
                        }
                        <PasswordChecklist
                            rules={["length", "specialChar", "number", "capital", "match"]}
                            minLength={8}
                            value={password}
                            valueAgain={confirmedpassword}
                            className={"tip-container"}
                            iconSize={12}
                        />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary login-button" title="Button to submit password set">Set Password</button>
                        <a href="/Login" title="Link to cancel setting the password">Cancel</a>
                    </div>
                </form>
                {message && <div className="help-block">{message}</div>}
            </div>
        );
    }
}
